import { render, staticRenderFns } from "./selfSupport_add_coupon.vue?vue&type=template&id=2ec2f027&scoped=true"
import script from "./selfSupport_add_coupon.vue?vue&type=script&lang=js"
export * from "./selfSupport_add_coupon.vue?vue&type=script&lang=js"
import style0 from "./selfSupport_add_coupon.vue?vue&type=style&index=0&id=2ec2f027&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec2f027",
  null
  
)

export default component.exports